import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import './styles/tokens.css';
import './styles/site.css';
import './styles/overnight.css';
import { App } from './App';
import { SiteNav } from './sections/nav';
import { SiteFooter } from './sections/closing';
import { BRAND } from './lib/site';

function NotFound() {
  useEffect(() => { document.title = `Page not found · ${BRAND}`; }, []);
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SiteNav routed />
      <main style={{ flex: 1, display: 'grid', placeItems: 'center', position: 'relative', overflow: 'hidden', padding: '140px 24px 80px' }}>
        <div aria-hidden="true" style={{ position: 'absolute', inset: 0, background: 'var(--bg-grid)', maskImage: 'radial-gradient(ellipse at center, black, transparent 70%)', WebkitMaskImage: 'radial-gradient(ellipse at center, black, transparent 70%)', pointerEvents: 'none' }}></div>
        <div className="crw-page-in" style={{ position: 'relative', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <span className="cr-label" style={{ color: 'var(--signal-400)' }}>404</span>
          <h1 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 'clamp(30px, 4.6vw, 46px)', fontWeight: 700, letterSpacing: 'var(--tracking-display)' }}>
            This page does not exist.
          </h1>
          <Link to="/" style={{ marginTop: 8, fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--signal-400)', textDecoration: 'none' }}>
            ← Back to the start
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
